module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/Hero_Chip@2x-bbefc57d5d174039.png"+" 134w",
        images: [{path: __webpack_public_path__ + "assets/images/Hero_Chip@2x-bbefc57d5d174039.png",width: 134,height: 140}],
        src: __webpack_public_path__ + "assets/images/Hero_Chip@2x-bbefc57d5d174039.png",
        toString: function(){return __webpack_public_path__ + "assets/images/Hero_Chip@2x-bbefc57d5d174039.png"},
        
        width: 134,
        height: 140
      }